<gymautow-sidebar
  [links]="links$ | async"
  [studioName]="studioName$ | async"
/>
